import {  Modal,Switchbox, Typography  } from "@weirgroup/weir-dls";
import { useTranslation } from "react-i18next";
import { BasicModalType } from "../../types/basic-modal.type";
import "./styles.scss"
import { useDarkMode } from "../../hooks/use-darkmode";

export default function ThemeModal(props: Readonly<BasicModalType>) {
  const { t } = useTranslation();
  const { open, toggleDialog } = props;
  const {darkMode} = useDarkMode()
    const toggleTheme = (e: any) =>{
        localStorage.setItem("darkMode", e.target.checked ? "true" : "false")
    }
  return (
    <Modal
      showModal={open}
      onClose={toggleDialog}
      size="small"
      dismissable
      darkMode={darkMode}
    >
    <Typography darkMode={darkMode} textAlign="center" variant="H4" color={darkMode ? "white" : "black"}>{t("selectTheme")}</Typography>
      <div className="theme-container">
        <Switchbox
            darkMode={darkMode}
            errorMessage=""
            label={"Dark Mode"}
            name="tester"
            outerContainerPadding="40px"
            checked={darkMode}
            onChange={toggleTheme}
        />
      </div>
    </Modal>
  );
}
